export default {
  guest: {
    earn_pts: 'Ganhe {{points}} pts nesta encomenda',
    tagline: 'Seja recompensado. Em cada encomenda, sempre.',
    pick_reward: 'Escolha o que quiser quando chegar lá',
    free_at: 'grátis com {{points}} pts',
    save_at: 'poupe {{amount}} com {{points}} pts',
    nearest: 'mais próximo',
    cta: 'Comece a ganhar — é gratuito',
    already_member: 'Já é membro?',
    sign_in: 'Iniciar sessão',
  },
  member: {
    earning_free: 'Está a ganhar comida grátis',
    every_euro_one: 'Por cada {{amount}} que gastar = 1 pt. Troque por itens gratuitos e descontos.',
    every_euro_other: 'Por cada {{amount}} que gastar = {{count}} pts. Troque por itens gratuitos e descontos.',
    until_redeem: '{{remaining}} pts até poder começar a resgatar',
    unlock_first: 'Esta encomenda só por si desbloqueia a sua primeira recompensa!',
    so_close: 'Tão perto de comida grátis!',
    just_more: 'Só mais {{remaining}} pts e pode começar a poupar.',
    pts_to_unlock: '{{remaining}} pts para desbloquear recompensas',
    this_order_unlocks: 'Esta encomenda leva-o aos {{points}} pts — pode resgatar na próxima encomenda!',
    save_next: 'Poupe até {{amount}} na próxima vez',
    pts_from_order: '+{{earned}} pts desta encomenda — só faltam {{remaining}}!',
    rewards_value: '= {{amount}} em recompensas',
    save_this_order: 'Poupe até {{amount}} nesta encomenda',
    use_pts: 'Use os seus {{points}} pts no checkout',
    earned_this_order: '+{{points}} pts ganhos nesta encomenda',
    current: 'Atual',
    from_this_order: '+{{points}} desta encomenda',
    expiration_zero: '{{points}} pts expiram hoje',
    expiration_one: '{{points}} pts expiram em 1 dia',
    expiration_other: '{{points}} pts expiram em {{count}} dias',
  },
};
